export default {
  i18n: {
    messages: {
      de: {
        buttons: {
          goToItem: 'Gehe zu Aufgabe',
        },
        fields: {
          text: 'Text',
          created: 'Erstellt',
          updated: 'Aktualisiert',
        },
      },
      en: {
        buttons: {
          goToItem: 'Go to task',
        },
        fields: {
          text: 'Text',
          created: 'Created',
          updated: 'Updated',
        },
      },
    },
  },
}
